// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"602":"70cbd803","956":"70cbd803"}[chunkId] + ".chunk.css";
};